import { render } from "./ChangeDisplayName.vue?vue&type=template&id=32ba6688&scoped=true"
import script from "./ChangeDisplayName.vue?vue&type=script&lang=js"
export * from "./ChangeDisplayName.vue?vue&type=script&lang=js"

import "./ChangeDisplayName.vue?vue&type=style&index=0&id=32ba6688&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ba6688"]])

export default __exports__